
export default function Footer() {
  return (
    <footer className="relative py-12 px-6 border-t border-purple-500/20 bg-gradient-to-br from-purple-900/10 to-pink-900/10">
      <div className="max-w-7xl mx-auto">
        <div className="text-center space-y-6">
          {/* Name & Tagline */}
          <div>
            <h3 className="text-3xl font-bold mb-2 bg-gradient-to-r from-white via-purple-200 to-pink-200 bg-clip-text text-transparent">
              Hafeez
            </h3>
            <p className="text-gray-400">
              Professional Thumbnail Designer • Creating Visual Stories That Convert
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center justify-center gap-4">
            <a
              href="https://www.instagram.com/hafeez.dsg/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-purple-600/20 border border-purple-500/30 rounded-full hover:bg-purple-600/40 transition-all duration-300 hover:scale-110 cursor-pointer"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a
              href="https://x.com/AbdulHafee92342"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center bg-purple-600/20 border border-purple-500/30 rounded-full hover:bg-purple-600/40 transition-all duration-300 hover:scale-110 cursor-pointer"
              aria-label="X (Twitter)"
            >
              <i className="ri-twitter-x-line text-xl"></i>
            </a>
          </div>

          {/* Copyright */}
          <div className="pt-6 border-t border-purple-500/20">
            <p className="text-gray-500 text-sm">
              © 2025 Hafeez Designer. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
